export const FALLBACK_FB_SDK_VERSION = 'v26.0';

export function resolveFbSdkVersion(fromConfig: unknown): string {
  if (typeof fromConfig === 'string' && /^v\d+\.\d+$/.test(fromConfig.trim())) {
    return fromConfig.trim();
  }
  return FALLBACK_FB_SDK_VERSION;
}
